
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../../constants';
import request from '../../../../components/Utils/httpHelper';
import {
    AUTOMATED_OVERRIDDING_RISKFACTOR_LIST,
    automatedOverriddingRiskFactorListSuccess,
    automatedOverriddingRiskFactorListFailure
} from './action';
import { SCORE_DEFINATION } from '../../../../config';

export function* automatedOveriddingRiskFactorList(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/automated/list`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(automatedOverriddingRiskFactorListSuccess(createResult));
    } catch (err) {
        yield put(automatedOverriddingRiskFactorListFailure(err))
    }
}
export function* listAutomatedOveriddingRiskFactor() {
    yield takeLatest(AUTOMATED_OVERRIDDING_RISKFACTOR_LIST, automatedOveriddingRiskFactorList);
}